"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M0 1a1 1 0 011-1h3a1 1 0 011 1v18a1 1 0 01-1 1H1a1 1 0 01-1-1V1zM7 1a1 1 0 011-1h4a1 1 0 011 1v18a1 1 0 01-1 1H8a1 1 0 01-1-1V1zM15 1a1 1 0 011-1h3a1 1 0 011 1v18a1 1 0 01-1 1h-3a1 1 0 01-1-1V1z"];
//# sourceMappingURL=layout-three-columns.js.map